/* API CLASSES */
import DjoserAPI from "../apis/DjoserAPI";
import CreatorAPI from "../apis/CreatorAPI";
// AXIOS INSTANCES
import { setBearerTokenForGemmiciApiServiceClient } from "../../core/apis/gemmiciApiService/AxiosIntance";
/* SERVICES */
/* OBJECT CLASSES */
import Creator from "../classes/Creator";
import ErrorToDisplay from "../../core/classes/ErrorToDisplay";

export default {
  // AXIOS SECTION AND LOGIN SECTION
  loginUser(authenticationData) {
    return new Promise((resolve, reject) => {
      DjoserAPI.JWTCreateAPI({
        username: authenticationData.username,
        password: authenticationData.password
      })
        .then(response => {
          localStorage.setItem("access_token", response.data.access);
          localStorage.setItem("refresh_token", response.data.refresh);
          this.setAuthorizationHeader(response.data.access);
          resolve(response.data.access);
        })
        .catch(error => {
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          const alert = new ErrorToDisplay(error.response);
          reject(alert);
        });
    });
  },
  logOutUser() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  },
  setAuthorizationHeader(accessToken) {
    setBearerTokenForGemmiciApiServiceClient(accessToken);
  },
  /* REGISTRATION SECTION */
  checkCreatorRegistrationCode(uuid) {
    return CreatorAPI.checkCreatorRegistrationCode(uuid);
  },
  checkUserRegistrationLink(uid, token) {
    return DjoserAPI.userActivateAPI(uid, token);
  },
  registerNewUser(user) {
    return new Promise((resolve, reject) => {
      DjoserAPI.userCreateAPI(user)
        .then(response => resolve(response))
        .catch(error => reject(new ErrorToDisplay(error.response)));
    });
  },
  registerNewCreator(username, uuid) {
    return new Promise((resolve, reject) => {
      CreatorAPI.createMyCreatorProfileAPI(username, uuid)
        .then(response => resolve(response))
        .catch(error => reject(new ErrorToDisplay(error.response)));
    });
  },
  createCreator(creator) {
    return new Creator({ ...creator });
  },
  editCreator(creator) {
    let profilePictureId;
    if (creator.profilePicture && creator.profilePicture.hasOwnProperty("id")) {
      profilePictureId = creator.profilePicture.id;
    } else {
      profilePictureId = null;
    }
    const payload = {
      first_name: creator.firstName,
      description: creator.description,
      websites: creator.websites,
      youtube_channel_urls: creator.youtubeChannelUrls,
      twitter_url: creator.twitterUrl,
      instagram_url: creator.instagramUrl,
      facebook_url: creator.facebookUrl,
      youtube_url: creator.youtubeUrl,
      pinterest_url: creator.pinterestUrl,
      profile_picture_id: profilePictureId
    };
    return CreatorAPI.putMyCreatorProfileAPI(payload);
  },
  /* PASSWORD SECTION */
  askForResetAccountPassword(email) {
    return DjoserAPI.resetPasswordAPI(email);
  },
  newPasswordAccount(uid, token, password) {
    return DjoserAPI.resetPasswordConfirmationAPI({
      uid,
      token,
      new_password: password
    });
  }
};
